import * as $ from "jquery";
import '../../node_modules/jquery.inputmask/dist/jquery.inputmask.bundle.js';



export class MaskService {

    public static createMask = (selector, maskName, validHandler?, invalidHandler?) => {
        let mask = MaskService.masks[maskName];
        if (mask.options.validHandler)
            mask.options.onComplete = validHandler;
        let element: any = $(selector);
        if (element && mask) {
            if (element.inputmask)
                element.inputmask(mask.mask, mask.options);
            else
                element.inputmask('mask', mask.mask, mask.options);
            element.blur(e => {
                MaskService.validateOnBlur(e, validHandler, invalidHandler);
            })
        }
    };


    public static hasMask = elem => $(elem).data("rawMaskFn");


    public static validate = elem => {
        return ($(elem) as any).inputmask("isComplete");
    }


    private static validateOnBlur = (e, validHandler?, invalidHandler?) => {
        if (MaskService.validate(e.target)) {
            if (validHandler) validHandler(e);
        }
        else {
            if (invalidHandler)
                invalidHandler(e);
        }
    }

    private static phoneMaskHackOptions = {
        placeholder: ' ',
        definitions: {
            'X': {
                validator: "[2-9]"
            }
        }
    }



    private static masks = {
        phone: {
            mask: '+{0,1}9{5,18}',
            options: { "placeholder": " " }
        },
        date: {
            mask: 'y.m.d. h:s',
            options: {
                hourFormat: 24,
                placeholder: 'éééé.hh.nn. óó.pp',
            }
        },
        year: {
            mask: '(20)|(1\\9)99',
            options: { "placeholder": " " }
        },
        zip: {
            mask: '9999',
            options: { "placeholder": "" }
        },
        email: {
            mask: 'Regex',
            options: { "regex": "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$", "placeholder": " " }
        },
        day: {
            // mask: 'integer',
            // options: { "placeholder": " ", min: 1, max: 31 }
            // mask: '9{1,2}',
            //  options: { "placeholder": "" }
            mask: '(y9)|(3z)|(x)',
            options: {
                definitions: {
                    'x': {
                        validator: "[1,2,3,4,5,6,7,8,9]"
                    },
                    'y': {
                        validator: "[1,2]",
                        cardinality: 1
                    },
                    'z': {
                        validator: "[0,1]",
                        cardinality: 1
                    }
                },
                "placeholder": " "
            }

        },
        phonePrefix: {
            mask: '+99',
            options: { "placeholder": " " }
        },
        idCard: {
            mask: '(AA999999)|(999999AA)',
            options: { "placeholder": "", "casing": "upper" }
        },
        drivingLicence: {
            mask: 'aa999999',
            options: { "placeholder": " ", "casing": "upper" }
        },
        passport: {
            mask: 'aa9999999',
            options: { "placeholder": " ", "casing": "upper" }
        },
        alpha: {
            mask: 'a{1,50}',
            options: { "placeholder": " " }
        },
        reg_number: {//cégjegyzék 
            mask: '99-99-99999',
            options: { "placeholder": " " }
        },
        tax_number: {
            mask: '99999999-9-99',
            options: { "placeholder": " " }
        },
        bank_account: {
            mask: '99999999-99999999-99999999',
            options: { "placeholder": " " }
        },
        street: {
            mask: "*{1,60} *{1,60}",
            options: { "placeholder": " " }
        },
        youtube_link: {
            mask: 'Regex',
            options: { "regex": "^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.?be)\/.+$", "placeholder": " " }
        },


    };



}